
import { supabase } from '@/integrations/supabase/client';
import { ProcurementCosts, CreateProcurementCostsInput } from '@/types/database.types';

export const createProcurementCosts = async (data: CreateProcurementCostsInput): Promise<ProcurementCosts> => {
  const { data: result, error } = await supabase
    .from('procurement_costs')
    .insert([data])
    .select()
    .single();

  if (error) {
    console.error('Error creating procurement costs:', error);
    throw error;
  }

  return result as ProcurementCosts;
};

export const getProcurementCosts = async (procurementId: string): Promise<ProcurementCosts | null> => {
  const { data, error } = await supabase
    .from('procurement_costs')
    .select('*')
    .eq('procurement_id', procurementId)
    .maybeSingle();

  if (error) {
    console.error('Error fetching procurement costs:', error);
    throw error;
  }

  return data as ProcurementCosts | null;
};

export const updateProcurementCosts = async (
  procurementId: string, 
  updates: Partial<CreateProcurementCostsInput>
): Promise<ProcurementCosts> => {
  const { data, error } = await supabase
    .from('procurement_costs')
    .update(updates)
    .eq('procurement_id', procurementId)
    .select()
    .single();

  if (error) {
    console.error('Error updating procurement costs:', error);
    throw error;
  }

  return data as ProcurementCosts;
};
